(() => {
  'use strict';
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const carousel = root.querySelector('[data-atlas-carousel]');
    const tabs = Array.from(carousel.querySelectorAll('[data-carousel-tab]'));
    const panels = Array.from(carousel.querySelectorAll('[data-carousel-panel]'));
    const position = carousel.querySelector('[data-carousel-position]');
    let current = 0;
    function select(index, focusTab = false) {
      current = (index + panels.length) % panels.length;
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === current));
        tab.tabIndex = i === current ? 0 : -1;
      });
      panels.forEach((panel, i) => {
        panel.setAttribute('aria-hidden', String(i !== current));
        panel.inert = i !== current;
      });
      position.textContent = `${current + 1} of ${panels.length}`;
      if (focusTab) tabs[current].focus({preventScroll:true});
    }
    if (panels.length) {
      carousel.dataset.enhanced = 'true';
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          const actions = {ArrowRight:current + 1, ArrowLeft:current - 1, Home:0, End:panels.length - 1};
          if (!(event.key in actions)) return;
          event.preventDefault();
          select(actions[event.key], true);
        });
      });
      carousel.querySelector('[data-carousel-prev]').addEventListener('click', () => select(current - 1));
      carousel.querySelector('[data-carousel-next]').addEventListener('click', () => select(current + 1));
      const area = carousel.querySelector('[data-carousel-slides]');
      let touchStart = null;
      area.addEventListener('pointerdown', event => {
        touchStart = null;
        if (event.pointerType !== 'touch' || event.target.closest('button,a,dialog,input,textarea,select,[contenteditable]') || String(window.getSelection()).length) return;
        touchStart = {x:event.clientX,y:event.clientY};
      });
      area.addEventListener('pointerup', event => {
        if (!touchStart) return;
        const dx = event.clientX - touchStart.x, dy = event.clientY - touchStart.y;
        touchStart = null;
        if (event.target.closest('button,a,dialog,input,textarea,select,[contenteditable]') || String(window.getSelection()).length) return;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.3) select(current + (dx < 0 ? 1 : -1));
      });
      area.addEventListener('pointercancel', () => {touchStart = null;});
      select(0);
    }
    root.querySelectorAll('[data-open-excerpt]').forEach(button => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.openExcerpt);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        dialog._returnFocus = button;
        dialog.showModal();
        dialog.querySelector('[data-close-excerpt]').focus();
      });
    });
    root.querySelectorAll('dialog.nv-lib-viewer').forEach(dialog => {
      dialog.querySelector('[data-close-excerpt]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
      dialog.addEventListener('close', () => {if(dialog._returnFocus) dialog._returnFocus.focus({preventScroll:true});});
    });
    const shop = root.querySelector('[data-featured-shop]');
    if (!shop) return;
    const cards = Array.from(shop.querySelectorAll('[data-featured-product]'));
    const filters = Array.from(shop.querySelectorAll('[data-series-filter]'));
    filters.forEach(button => button.addEventListener('click', () => {
      const selected = button.dataset.seriesFilter;
      let count = 0;
      cards.forEach(card => {
        const show = selected === 'all' || card.dataset.series.split('|').includes(selected);
        card.hidden = !show;
        if(show) count++;
      });
      filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
      shop.querySelector('[data-featured-empty]').hidden = count > 0;
      shop.querySelector('[data-featured-status]').textContent = `${count} featured ${count === 1 ? 'kit' : 'kits'} shown. Browse all kits for the complete library.`;
    }));
  }
  const scan = container => container.querySelectorAll('[data-nv-library]').forEach(initialize);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
